
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import classof$1 from './classof.js';

var classof = classof$1;

var $String = String;

var toString = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

export { toString as default };
//# sourceMappingURL=to-string.js.map
